import { ErpFeatureKeys } from "../models/erpFeature";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ErpFeatureState {
  isEnabled: boolean;
  params: Record<string, unknown>;
}

export type ErpFeaturesState = {
  [key in ErpFeatureKeys]?: ErpFeatureState;
};

const initialState: ErpFeaturesState = Object.values(ErpFeatureKeys).reduce(
  (acc, key) => {
    acc[key] = {
      isEnabled: false,
      params: {},
    };
    return acc;
  },
  // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, @typescript-eslint/consistent-type-assertions
  {} as ErpFeaturesState,
);

export const erpFeaturesSlice = createSlice({
  name: "erpFeatures",
  initialState,
  reducers: {
    setFeatureState: (
      state,
      action: PayloadAction<{
        feature: ErpFeatureKeys;
        isEnabled: boolean;
        params: Record<string, unknown>;
      }>,
    ) => {
      const { feature, isEnabled, params } = action.payload;
      state[feature] = {
        isEnabled,
        params,
      };
    },
    resetFeatures: () => initialState,
  },
});

export const { setFeatureState, resetFeatures } = erpFeaturesSlice.actions;

export default erpFeaturesSlice.reducer;
